import { CALL_API, Schemas } from '../../../common/middleware/api';
import globalize from '../../../common/services/globalize';
import moment from 'moment';

export const ROYALTY_REPORT_REQUEST = 'ROYALTY_REPORT_REQUEST';
export const ROYALTY_REPORT_SUCCESS = 'ROYALTY_REPORT_SUCCESS';
export const ROYALTY_REPORT_FAILURE = 'ROYALTY_REPORT_FAILURE';

export const ROYALTY_REPORT_EXPORT_REQUEST = 'ROYALTY_REPORT_EXPORT_REQUEST';
export const ROYALTY_REPORT_EXPORT_SUCCESS = 'ROYALTY_REPORT_EXPORT_SUCCESS';
export const ROYALTY_REPORT_EXPORT_FAILURE = 'ROYALTY_REPORT_EXPORT_FAILURE';

export const ROYALTY_REPORT_PAYMENTS_EXPORT_REQUEST = 'ROYALTY_REPORT_PAYMENTS_EXPORT_REQUEST';
export const ROYALTY_REPORT_PAYMENTS_EXPORT_SUCCESS = 'ROYALTY_REPORT_PAYMENTS_EXPORT_SUCCESS';
export const ROYALTY_REPORT_PAYMENTS_EXPORT_FAILURE = 'ROYALTY_REPORT_PAYMENTS_EXPORT_FAILURE';

export const loadRoyaltyReport = (options) => ({
	[CALL_API]: {
		types: [ROYALTY_REPORT_REQUEST, ROYALTY_REPORT_SUCCESS, ROYALTY_REPORT_FAILURE],
		endpoint: `api/reports/royalty`,
		request: options,
		schema: Schemas.ROYALTY_REPORT_ARRAY,
		form: 'royaltyReportFilter'
	}
});

export const exportRoyaltyReport = (exportFormat, options, values, onSuccessEvent) => (dispatch, getState) => {
	const { configuration, entities } = getState();
	const term = options && options.termId && entities.terms[options.termId];

	dispatch({
		[CALL_API]: {
			types: [ROYALTY_REPORT_EXPORT_REQUEST, ROYALTY_REPORT_EXPORT_SUCCESS, ROYALTY_REPORT_EXPORT_FAILURE],
			endpoint: `api/reports/royalty/export/${exportFormat === 'Xero' ? 'xero' : ''}`,
			request: {
				...options,
				...values,	// additional values for Xero export
				timeZone: globalize.getCurrentTimeZone(configuration.franchisor)
			},
			form: 'royaltyReportFilter',
			onSuccessEvent
		},
		format: exportFormat,
		filename: () => {
			return `RoyaltyReport-${buildFilterSuffix(options, term)}.${exportFormat === 'Xero' ? 'csv' : 'xlsx'}`;
		}
	});
};

export const exportRoyaltyPayments = (options, onSuccessEvent) => (dispatch, getState) => {
	const { configuration, entities } = getState();
	const term = options && options.termId && entities.terms[options.termId];

	dispatch({
		[CALL_API]: {
			types: [ROYALTY_REPORT_PAYMENTS_EXPORT_REQUEST, ROYALTY_REPORT_PAYMENTS_EXPORT_SUCCESS, ROYALTY_REPORT_PAYMENTS_EXPORT_FAILURE],
			endpoint: `api/reports/royalty/exportPayments`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(configuration.franchisor)
			},
			form: 'royaltyReportFilter',
			onSuccessEvent
		},
		format: 'Excel',
		filename: () => `RoyaltyReportPayments-${buildFilterSuffix(options, term)}.xlsx`
	});
};

const buildFilterSuffix = (filter, term) => {
	let filterString = "";
	if (filter) {
		const { termId, startDate, endDate } = filter;
		if (termId) {
			filterString = `(term-${term ? term.name : termId})`;
		}
		else {
			filterString = `(from ${moment(startDate).format('YYYY-MM-DD')} to ${moment(endDate).format('YYYY-MM-DD')})`;
		}
	}
	return filterString;
};
